
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcCommunicationTable as ObcCommunicationTableElement} from '@oicl/openbridge-webcomponents/dist/components/communication-table/communication-table.js';
 import {ObcCommunicationTableRowClickEvent} from '@oicl/openbridge-webcomponents/dist/components/communication-table/communication-table.js';
 export type {ObcCommunicationTableRowClickEvent} from '@oicl/openbridge-webcomponents/dist/components/communication-table/communication-table.js';
 

 
 export const ObcCommunicationTable = createComponent({
   react: React,
   tagName: 'obc-communication-table',
   elementClass: ObcCommunicationTableElement,
   events: {
     
     onRowClick: 'row-click' as EventName<ObcCommunicationTableRowClickEvent>,
   }
  });
 
 